import { AppThunk } from '../../types';
import {} from '../../../API/order/title/adminTaxCertificationAPI';
import {
  getTaxCertificationRequestAsyncAction,
  postCancelTaxCertificationAsyncAction,
  postCreateTaxCertificationRequestAsyncAction,
} from './reducer';

export const createTaxCertification =
  (orderId: string): AppThunk =>
  async (dispatch) => {
    await dispatch(postCreateTaxCertificationRequestAsyncAction(orderId));
    await dispatch(getTaxCertificationRequestAsyncAction(orderId));
  };

export const cancelTaxCertification =
  (orderId: string, taxCertificationRequestId: string): AppThunk =>
  async (dispatch) => {
    await dispatch(postCancelTaxCertificationAsyncAction(taxCertificationRequestId));
    await dispatch(getTaxCertificationRequestAsyncAction(orderId));
  };
